const secondary = {
    social_bind_with: 'Bạn đã có tài khoản? Đăng nhập để liên kết {{methods, list(type: disjunction;)}} với danh tính xã hội của bạn.',
};
export default Object.freeze(secondary);
